// extracted by mini-css-extract-plugin
module.exports = {"popper":"styles_popper__LZKXD"};